import type { PostingsRolesDataQuery } from '@revelio/data-access';

import {
  type BreakdownData,
  type BreakdownSingleDataSet,
  DataType,
  type SingleDataPoint,
} from '../types';

export const convertPostingTopData = ({
  data,
}: {
  data: PostingsRolesDataQuery['posting'];
}): BreakdownSingleDataSet => {
  const breakdownDataPoints: Record<
    string,
    BreakdownData<SingleDataPoint>
  > = {};

  data?.forEach((posting) => {
    const primaryDim = posting?.metadata?.shortName;
    const primaryLongName = posting?.metadata?.longName;
    const primaryId = posting?.metadata?.id;

    if (!primaryDim) return;

    posting?.category?.forEach((categoryPoint) => {
      const dim = categoryPoint?.metadata?.shortName;

      const value = categoryPoint?.metrics?.count;
      const share = categoryPoint?.metrics?.share;

      if (!dim) return;
      breakdownDataPoints[dim] = {
        dim,
        breakdown: [
          ...(breakdownDataPoints[dim]?.breakdown ?? []),
          {
            dim: primaryDim,
            longName: primaryLongName ?? null,
            value: value ?? null,
            share: share ?? null,
            id: primaryId ? String(primaryId) : null,
          },
        ],
      };
    });
  });

  const breakdownData: BreakdownSingleDataSet['data'] =
    Object.values(breakdownDataPoints);

  return {
    type: DataType.BREAKDOWN_SINGLE,
    data: breakdownData,
  };
};
